import React from 'react'
import ImageryUsageComponent from '../../components/marketingGuidelines/marketingComponents/ImageryUsage/ImageryUsageComponent'
import { Col } from 'react-bootstrap';
import './imageryUsageLayout.scss'

class ImageryUsageLayout extends React.Component {
    render() {
        return <div className="imagery-layout">
            <div className="warning-section">
                <Col xs={1} align="center">
                    <span className='icon-warning-grey' />
                </Col>
                <p>Use of the Life Fitness logo requires the expressed written consent from Life Fitness. Contact <a href="mailto:developers@lifefitness.com">developers@lifefitness.com</a> for information.</p>
            </div>
            <br />
            <h2>Imagery Usage</h2>
            <ImageryUsageComponent />
        </div>
    }
}

export default ImageryUsageLayout



// WEBPACK FOOTER //
// ./src/layouts/ImageryUsage/ImageryUsageLayout.js